export default "__VITE_ASSET__ba9bc644__"